import React, { createRef, forwardRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import EnterViewportAnimation from "../EnterViewportAnimation";
import "./style.scss";

const HeroDetailsBox = forwardRef((props, ref) => {
  ref = ref || createRef({});
  const {
    theme = "smke",
    id = null,
    className = null,
    style = {},
    children,
    ...rest
  } = props;

  const classes = classNames(
    "cockpit-hero_details_box",
    "theme-" + theme,
    className
  );

  return (
    <div ref={ref} key={id} id={id} {...rest} className={classes} style={style}>
      <EnterViewportAnimation mode="fade-up">{children}</EnterViewportAnimation>
    </div>
  );
});
HeroDetailsBox.displayName = "HeroDetailsBox";

HeroDetailsBox.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  theme: PropTypes.string
};

export default HeroDetailsBox;
